import React, { useEffect } from "react";
import { Footer } from "../../Components/Footer/Footer";
import { Header } from "../../Components/Header/Header";
import { PageHeader } from "../../Components/PageHeader/PageHeader";
import { useApp } from "../../context/AppContextProvider";
import { enviroment } from "../../enviroment";
import SeoDefault from "../../Components/Seo/SeoDefault";
import SidebarContentLayout from "../../Components/SidebarContentLayout/SidebarContentLayout";

export const Privacy = () => {
  const appData = useApp();
  let windowWidth = appData.appData.windowWidth;

  // Privacy policy content in JSON format with HTML
  const privacyContent = {
    title: "Ashi Electronics Privacy Policy",
    effectiveDate: "2024-02-29",
    sections: [
      {
        id: "intro",
        title: "Introduction",
        content: [
          "<p>This Privacy Policy describes how Ashi Electronics owned and operated by ASHI RETAIL ENTERPRISES (\"we,\" \"us,\" or \"our\") collects, uses, and discloses your personal information when you visit our website at ashielectronics.com owned and operated by ASHI RETAIL ENTERPRISES (the \"Site\") or make purchases at our physical store located at SHOP NO. -4, KAUSHIK COMPLEX, SECTOR-17,NEAR PNB BANK SUKHRALI, SUKHRALI, Gurgaon, Haryana, 122001. (the \"Store\").</p>"
        ]
      },
      {
        id: "info-collect",
        title: "Information We Collect",
        content: [
          "<p>We collect the following types of information:</p>",
          "<ul>",
          "<li><span class=\"c6\">Personal Information:</span> <span class=\"c2\">This includes information that can be used to identify you, such as your name, email address, phone number, billing and shipping address, and payment information.</span></li>",
          "<li><span class=\"c6\">Device Information:</span> <span class=\"c2\">This includes information about your device, such as your browser type, IP address, operating system, and referring website/URL.</span></li>",
          "<li><span class=\"c6\">Usage Information:</span> <span class=\"c2\">This includes information about your activity on the Site, such as the pages you visit, the products you view, and the searches you perform.</span></li>",
          "</ul>"
        ]
      },
      {
        id: "info-collect-method",
        title: "How We Collect Information",
        content: [
          "<p>We collect information in the following ways:</p>",
          "<ul>",
          "<li><span class=\"c6\">When you create an account or make a purchase:</span> <span class=\"c2\">We collect your personal information when you create an account on the Site or make a purchase in the Store or online.</span></li>",
          "<li><span class=\"c6\">When you browse the Site:</span> <span class=\"c2\">We collect device information and usage information automatically when you browse the Site.</span></li>",
          "<li><span class=\"c6\">From third-party sources:</span> <span class=\"c2\">We may collect information about you from third-party sources, such as social media platforms, when you allow them to share your information with us.</span></li>",
          "</ul>"
        ]
      },
      {
        id: "info-use",
        title: "How We Use Your Information",
        content: [
          "<p>We use your information for the following purposes:</p>",
          "<ul>",
          "<li><span class=\"c2\">To fulfill your orders and provide customer service.</span></li>",
          "<li><span class=\"c2\">To manage your account on the Site.</span></li>",
          "<li><span class=\"c2\">To send you marketing and promotional communications (with your consent).</span></li>",
          "<li><span class=\"c2\">To personalize your experience on the Site.</span></li>",
          "<li><span class=\"c2\">To improve the Site and our services.</span></li>",
          "<li><span class=\"c2\">To prevent fraud and maintain the security of the Site.</span></li>",
          "</ul>"
        ]
      },
      {
        id: "info-share",
        title: "Sharing Your Information",
        content: [
          "<p>We may share your information with third-party service providers who help us operate the Site and provide our services. These service providers are contractually obligated to keep your information confidential and to use it only for the purposes for which it is disclosed to them.</p>",
          "<p>We may also disclose your information if we are required to do so by law or if we believe that such disclosure is necessary to protect the rights, property, or safety of ourselves or others.</p>"
        ]
      },
      {
        id: "info-choices",
        title: "Your Choices",
        content: [
          `<p><span class="c9">You can choose not to receive marketing and promotional communications from us by following the unsubscribe instructions in any email we send you. You can also access, update, or delete your personal information by contacting us at </span><span class="c1">${enviroment.EMAIL_ADDRESS}</span></p>`
        ]
      },
      {
        id: "info-retention",
        title: "Data Retention",
        content: [
          "<p><span class=\"c2\">We will retain your information for as long as necessary to fulfill the purposes for which it was collected, unless a longer retention period is required or permitted by law.</span></p>"
        ]
      },
      {
        id: "info-security",
        title: "Security",
        content: [
          "<p><span class=\"c2\">We take reasonable steps to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no website or internet transmission is completely secure, and we cannot guarantee the security of your information.</span></p>"
        ]
      },
      {
        id: "info-children",
        title: "Children's Privacy",
        content: [
          "<p><span class=\"c2\">Our Site is not directed to children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and you believe that your child has provided us with personal information, please contact us at [email protected] so we can delete the information.</span></p>"
        ]
      },
      {
        id: "info-changes",
        title: "Changes to this Privacy Policy",
        content: [
          "<p><span class=\"c2\">We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on the Site. You are advised to review this Privacy Policy periodically for any changes.</span></p>"
        ]
      },
      {
        id: "info-contact",
        title: "Contact Us",
        content: [
          `<p><span class="c9">If you have any questions about this Privacy Policy, please contact us at </span><span class="c15 c16"><a class="c7" href="mailto:${enviroment.EMAIL_ADDRESS}">${enviroment.EMAIL_ADDRESS}</a></span><span class="c6"> </span><span class="c9">or by phone at </span><span class="c1">${enviroment.PHONE_NUMBER}</span></p>`
        ]
      }
    ]
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <SeoDefault
        title={`Privacy Policy - ${enviroment.BUSINESS_NAME}`}
        description={`Read ${enviroment.BUSINESS_NAME}'s privacy policy to understand how we protect your data and ensure a safe shopping experience.`}
        keywords={`${enviroment.BUSINESS_NAME} privacy policy, data protection, electronics, appliances, buy online`}
        canonicalUrl={`${process.env.REACT_APP_URL}/privacy-policy`}
        pageType="website"
        breadcrumbItems={[
          { name: "Home", url: `${process.env.REACT_APP_URL}/` },
          { name: "Privacy Policy", url: `${process.env.REACT_APP_URL}/privacy-policy` },
        ]}
      />
      {windowWidth === "mobile" ? (
        <PageHeader title="Privacy" hide={true} />
      ) : (
        <Header />
      )}
      <section className="section col-md-12">
        <div className="container">
          <SidebarContentLayout contentData={privacyContent} />
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};
